<script>
import api from '@/utils/api';

export default {
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    userData() {
      return this.$store.state.userData;
    },
    client() {
      return this.$store.state.client;
    },
    clientSlugFromRoute() {
      try {
        return this.$route.params.clientSlug || this.$route.params.client_slug || null;
      } catch (e) {
        return null;
      }
    },
  },
  methods: {
    async fetchPrograms(clientSlug = null) {
      this.loading = true;

      // Clear old data immediately so we don't show the previous user's programs
      this.$store.commit('programs', []);

      try {
        let url = 'programs/';
        // Only use client-specific endpoint when we have an explicit client context from the URL
        // (e.g. /acme/profile). Using programs/ for the main profile lets the backend apply the
        // 90% rule for base TBL users and return client programs for client users.
        const slug = clientSlug ?? this.clientSlugFromRoute;
        if (slug) {
          url = `clients/${slug}/programs/`;
        }

        const requestConfig = { url, method: 'GET' };
        // The program endpoints require authentication to show user-specific data
        if (this.userData && this.userData.drf_token) {
          requestConfig.headers = {
            Authorization: `Token ${this.userData.drf_token}`,
          };
        }
        const programsResponse = await api(requestConfig);

        if (programsResponse.ok) {
          let programs = programsResponse.body;
          // Ensure array (handle unpaginated list response)
          if (!Array.isArray(programs)) {
            programs = programs && programs.results ? programs.results : [];
          }
          this.$store.commit('programs', programs);
        }
      } catch (e) {
        // Error fetching programs - silently handle
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
